import React from 'react'
import { Form, Input } from 'antd'
import { LABELS, LABEL_NAME_FIELD, LABEL_SELECTOR_FIELD, LABEL_KEYS, SUCCESS } from 'views/ScanSettings/NewScan/constants'
import DynamicForm from 'views/ScanSettings/NewScan/components/DynamicForm'
import { remoteValidation, extractResponse } from '../steps/validate';

const Labels = ({ form, labels, setValidationError }) => {
	const { getFieldDecorator } = form

	const onRemoteValidation = async (values) => {		
		try{
			let failureResponse = { origin: 'server', errors: [] }
			if (values) 
			{
				let response = await remoteValidation(values, LABEL_KEYS, '/global/labels/validate', failureResponse)
				response = extractResponse(response)
				failureResponse = response && !!response.length ? response : failureResponse
			}
			return !!failureResponse.errors.length ? failureResponse : SUCCESS;
		}
		catch(err){
			setValidationError(Array.isArray(err) ? err : [err.message]);
		}
	}

	return (
		<DynamicForm
			remoteValidation={async (values) => await onRemoteValidation(values)}
			form={form}
			dataList={labels}
			dataType={LABELS}
			dataTypeText="Labels"
			formFields={[LABEL_NAME_FIELD, LABEL_SELECTOR_FIELD]}
			nameProp={LABEL_NAME_FIELD}
			setValidationError={setValidationError}
		>
			<Form.Item label="NAME">
				{getFieldDecorator(LABEL_NAME_FIELD, {
					validateTrigger: ['onChange', 'onBlur'],
					rules: [
						{
							required: true,
							whitespace: true,
							message: 'Label Name is Required.'
						}
					]
				})(<Input placeholder="Name" />)}
			</Form.Item>
			<Form.Item label="SELECTOR">
				{getFieldDecorator(LABEL_SELECTOR_FIELD, {
					validateTrigger: ['onChange', 'onBlur'],
					rules: [
						{
							required: true,
							whitespace: true,
							message: 'Label Selector is Required.'
						}
					]
				})(<Input placeholder="Selector" />)}
			</Form.Item>
		</DynamicForm>
	)
}
export default Labels
